module.exports = __webpack_public_path__ + "img/93.072c8d97.jpg";